module.exports = __webpack_public_path__ + "static/media/paypal-icon.a27ba38c.png";